module.exports = __webpack_public_path__ + "d1b0754c83f887add76cc7862f01fb84.svg";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/tr/reports-ordered.svg
// module id = 680
// module chunks = 0